import axios from 'axios';

const baseURL = 'https://www.theindianthing.com/shiva-statue/index.php/wp-json';

// Create a cache object to store fetched data
const cache = {};

// Create an axios instance with base URL
const axiosInstance = axios.create({
  baseURL: baseURL
});

export const fetchData = async (endpoint) => {
  try {
    if (cache[endpoint]) {
      // If data is already in cache, return it
      return cache[endpoint];
    } else {
      const response = await axiosInstance.get(endpoint);
      const data = response.data;

      // Cache the fetched data
      cache[endpoint] = data;

      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getHeaderData = async () => {
  try {
    const data = await fetchData('/header-endpoint');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getFooterData = async () => {
  try {
    const data = await fetchData('/footer-endpoint');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getHomeHeroBannerData = async () => {
  try {
    const data = await fetchData('/wp/v2/heroBanner');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getHeaderNotification = async () => {
  try {
    const data = await fetchData('/wp/v2/headernotification');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getPressMedia = async () => {
  try {
    const data = await fetchData('/wp/v2/pressmedia');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getnearbyData = async (id) => {
  try {
    const data = await fetchData('/wp/v2/nearby_places');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getHomeOffersData = async (id) => {
  try {
    const data = await fetchData('/wp/v2/homeoffers');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};


export const getHomeAttractionsData = async (id, sliceCount) => {
  try {
    const data = await fetchData('/wp/v2/exploreattractions?per_page=100');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return sliceCount ? matchedItems.slice(0, sliceCount) : matchedItems;
    } else {
      return sliceCount ? data.slice(0, sliceCount) : data;
    }
  } catch (error) {
    throw error;
  }
};

export const getStoryBehindVishwarooData = async () => {
  try {
    const data = await fetchData('/wp/v2/storybehindvishwaroo');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getVisitorTestimonialData = async (id, sliceCount) => {
  try {
    const data = await fetchData('/wp/v2/visitortestimonial');
    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return sliceCount ? matchedItems.slice(0, sliceCount) : matchedItems;
    } else {
      return sliceCount ? data.slice(0, sliceCount) : data;
    }
  } catch (error) {
    throw error;
  }
};

export const getFaqsData = async () => {
  try {
    const data = await fetchData('/wp/v2/faqs?per_page=100');
    return data;
  } catch (error) {
    throw error;
  }
};

export const getLatestHappeningsData = async (id, sliceCount) => {
  try {
    const data = await fetchData('/wp/v2/latest_happenings?per_page=100');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return sliceCount ? matchedItems.slice(0, sliceCount) : matchedItems;
    } else {
      return sliceCount ? data.slice(0, sliceCount) : data;
    }
  } catch (error) {
    throw error;
  }
};

export const getPoliciesData = async (id) => {
  try {
    const data = await fetchData('/wp/v2/policiesdocuments');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getThingsToDoData = async (id) => {
  try {
    const data = await fetchData('/wp/v2/footerthingstodo');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getParkhelpData = async (id) => {
  try {
    const data = await fetchData('/wp/v2/footerhelp');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getParkStayData = async (id) => {
  try {
    const data = await fetchData('/wp/v2/footerparkdetails');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getHomeModalData = async (id) => {
  try {
    const data = await fetchData('/wp/v2/homemodal');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getTandC = async (id) => {
  try {
    const data = await fetchData('/wp/v2/bookingdisclaimer');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

export const getVideoGallery = async (id) => {
  try {
    const data = await fetchData('/wp/v2/videogallery');

    if (id) {
      const matchedItems = data.filter(item => item.id == id);
      return matchedItems;
    } else {
      return data;
    }
  } catch (error) {
    throw error;
  }
};
